import React from 'react';
import { useTranslation } from 'react-i18next';

import SettingsRules from './SettingsRules/SettingsRules';
import { logicOperatorTypes } from '../../config/constants';
import ColorPicker from '../Shared/ColorPicker/ColorPicker';
import './style.css';
import './SettingsRules/SettingsRules.css';

var PinColors = function(props) {
  var value = props.value;
  var fields = props.fields;
  var fetchSettingsOperators = props.fetchSettingsOperators;
  var disabled = props.disabled;
  var onChange = props.onChange;

  var t = useTranslation().t;

  var handleRuleSetChange = function(pinColorIndex, ruleSet) {
    var newValue = value.slice();
    newValue[pinColorIndex] = Object.assign({}, newValue[pinColorIndex], { ruleSet: ruleSet });
    onChange(newValue);
  };

  var handleColorChange = function(pinColorIndex, color) {
    var newValue = value.slice();
    newValue[pinColorIndex] = Object.assign({}, newValue[pinColorIndex], { color: color });
    onChange(newValue);
  };

  var handleAddPinColor = function() {
    onChange(value.concat([{
      color: '#ea4335',
      ruleSet: {
        rules: [],
        andOr: logicOperatorTypes.AND,
      },
    }]));
  };

  var handleRemovePinColor = function(pinColorIndex) {
    var newValue = value.slice();
    newValue.splice(pinColorIndex, 1);
    onChange(newValue);
  };

  return (
    <div className="pin-colors-list">
      {value && value.map(function(pinColor, index) {
        return (
          <div className="pin-color-card" key={index}>
            <div className="pin-color-header">
              <div className="pin-color-remove">
                <button
                  type="button"
                  className="settings-rule-remove-btn"
                  onClick={function() { handleRemovePinColor(index); }}
                  disabled={disabled}
                  aria-label={t('btn:remove')}
                >
                  <i className="material-icons">close</i>
                </button>
              </div>
            </div>
            <SettingsRules
              label={[
                <span className="pin-color-label" key="color-label-field">
                  {t('common:color')}
                </span>,
                <ColorPicker
                  key="color-picker"
                  value={pinColor.color}
                  onChange={function(color) { handleColorChange(index, color); }}
                  disabled={disabled}
                />,
                <span className="pin-color-label" key="color-label-match">
                  {t('settings:matchPins')}
                </span>,
              ]}
              value={pinColor.ruleSet}
              onChange={function(ruleSet) { handleRuleSetChange(index, ruleSet); }}
              fields={fields}
              fetchSettingsOperators={fetchSettingsOperators}
              disabled={disabled}
            />
          </div>
        );
      })}
      <div className="settings-rules-add">
        <button type="button" className="settings-add-btn" onClick={handleAddPinColor} disabled={disabled}>
          <span className="material-symbols-outlined">add</span>
          {t('btn:addColor')}
        </button>
      </div>
    </div>
  );
};

export default PinColors;
